import { useEffect, useMemo, useState } from "react";
import { FirestoreService } from "../../../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../../api/firebase/references";
import { PortalConfig } from "../../../../data-model/portalConfigForDraftSubmission";

interface PortalConfigForDraftSubmission {
  portalConfig: PortalConfig[];
  loading: boolean;
  error: string | null;
}
export const usePortalConfigForDraftSubmission = () => {
  const [portalConfigData, setPortalConfigData] =
    useState<PortalConfigForDraftSubmission>({
      portalConfig: [],
      loading: false,
      error: null,
    });

  const getPortalConfigForDraftSubmission = async () => {
    try {
      setPortalConfigData((prev) => ({ ...prev, loading: true }));
      const response = await FirestoreService.getAllDocuments(
        FirestoreCollectionReference.allPortalsForDraftSubmission(),
      );
      setPortalConfigData((prev) => ({
        ...prev,
        portalConfig: response as unknown as PortalConfig[],
        loading: false,
      }));
    } catch (error) {
      setPortalConfigData((prev) => ({
        ...prev,
        error: error as string,
        loading: false,
      }));
    }
  };

  const getPortalConfigOptions = useMemo(() => {
    return (
      portalConfigData?.portalConfig?.map((portal: PortalConfig) => ({
        label: portal?.portal_name ?? "",
        value: portal?.portal_id ?? "",
      })) ?? []
    );
  }, [portalConfigData.portalConfig]);

  useEffect(() => {
    getPortalConfigForDraftSubmission();
  }, []);

  return { portalConfigData, getPortalConfigOptions };
};
